import { LinkYearsClassrooms } from "../models/dto/link-years-classrooms"

export const buildLinkYearsClassroom = (year: string, classrooms: string, idsClassrooms: string[]): LinkYearsClassrooms => {
  return {
    year: year,
    classrooms: classrooms,
    idsClassrooms: idsClassrooms
  }
}
